import React from "react";
import { TimingsForm } from "../data-forms/TimingsForm";
import { TimingsFormWrapper } from "../data-forms/TimingsFormWrapper";
import { DialogActions, DialogContent, Button } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { timingsApiSlice } from "src/api/timingsApiSlice";
import { AddEditService } from "../services/AddEditService";

const DialogHandler = (props) => {
  const { subject, action, id } = props;
  const [searchParams, setSearchParams] = useSearchParams();
  const handleClose = () => {
    setSearchParams({});
  };

  const handleSaveTimings = () => {
    alert("Saving timings");
  };
  const prepDialogContent = () => {
    switch (props.subject) {
      case "timings":
        return (
          <TimingsFormWrapper
            type={props.action}
            saveHandler={handleSaveTimings}
          />
        );
      case "services":
        return <AddEditService {...props} />;
      default:
        return "Default";
    }
  };
  return (
    <>
      {" "}
      <DialogContent>{prepDialogContent()}</DialogContent>{" "}
      {/* <DialogActions>
        {action == "add" || action == "edit" ? (
          <Button variant="contained" onClick={handleClose}>
            Save
          </Button>
        ) : null}
        <Button variant="outlined" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>{" "} */}
    </>
  );
};

export { DialogHandler };
